var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99935,
    cy: 10.0013,
    r: 7.5,
    stroke: "#A0A5B5",
    strokeWidth: 1.66667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0007,
    cy: 13.1237,
    r: 1.04167,
    fill: "#A0A5B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91602 7.91667C7.91602 6.99619 8.84876 6.25 9.99935 6.25C11.1499 6.25 12.0827 6.99619 12.0827 7.91667C12.0827 8.72347 11.3661 9.39637 10.4143 9.55027C10.1871 9.587 9.99935 9.76988 9.99935 10V10.4167",
    stroke: "#A0A5B5",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.86d2206ca3822628b5a5980dc4431413.svg";
export { ForwardRef as ReactComponent };